<footer>
	<div class="newsletter-container">
<!--		<h2 i18n="@@footer-newsletter-title|Newsletter section title">Subscríbete y disfruta los resultados</h2>-->
<!--		<p class="newsletter-subscription-text" i18n="@@footer-newsletter-text|Newsletter subscription description">-->
<!--			Todo lo que necesitas saber sobre la forma más eficiente de cultivar en un solo lugar, suscríbete a nuestro-->
<!--			boletín informativo.-->
<!--		</p>-->
<!--		<iframe src="https://cdn.forms-content.sg-form.com/b42b0ba0-aba7-11ed-84e9-eaea2d7a5942" class="newsletter-iframe"></iframe>-->
	</div>
	<div class="social-links-container">
		<h2 i18n="@@footer-follow-us|Follow us section title">Síguenos</h2>
		<div class="social-links">
			<a mat-icon-button class="social-links-item app-elevation1" [class.app-16]="(isXXSmallWindow | async)?.matches" [class.app-24]="!((isXXSmallWindow | async)?.matches)" href="https://wa.me/{{environment.contact.phone.replace('+','')}}" target="_blank" aria-label="Whatsapp">
				<mat-icon aria-label="whatsapp" [svgIcon]="'app-whatsapp'"></mat-icon>
			</a>
			<a mat-icon-button class="social-links-item app-elevation1" [class.app-16]="(isXXSmallWindow | async)?.matches" [class.app-24]="!((isXXSmallWindow | async)?.matches)" [href]="environment.contact.instagram" target="_blank" aria-label="Intagram">
				<mat-icon aria-label="instagram" [svgIcon]="'app-instagram'"></mat-icon>
			</a>
			<a mat-icon-button class="social-links-item app-elevation1" [class.app-16]="(isXXSmallWindow | async)?.matches" [class.app-24]="!((isXXSmallWindow | async)?.matches)" [href]="environment.contact.facebook" target="_blank" aria-label="Facebook">
				<mat-icon aria-label="facebook" [svgIcon]="'app-facebook'"></mat-icon>
			</a>
			<a mat-icon-button class="social-links-item app-elevation1" [class.app-16]="(isXXSmallWindow | async)?.matches" [class.app-24]="!((isXXSmallWindow | async)?.matches)" [href]="environment.contact.x" target="_blank" aria-label="X">
				<mat-icon aria-label="X" [svgIcon]="'app-x'"></mat-icon>
			</a>
		</div>
	</div>
	<div class="legal-links">
		<a [routerLink]="['/privacy-policy']" i18n="@@footer-privacy-policy|Footer link to the privacy policy">Política de privacidad</a>
		<a [routerLink]="['/terms-of-use']" i18n="@@footer-terms-of-use|Footer link to the terms of use">Términos de uso</a>
		<a [routerLink]="['/envios']" i18n="@@footer-shipping-policy|Footer link to the shipping policy">Política de envíos</a>
		<button type="button" class="cookie-settings-button" (click)="openCookieSettings()" i18n="@@footer-cookie-settings|Footer button that reopens the cookie consent banner">Configuración de cookies</button>
	</div>
</footer>
